import React from "react";

import models from "@aeo/core/models";
import { GenericObject } from "@aeo/core/types";

export const ApplicationContext = React.createContext<
  (models.ActiveApplication & GenericObject) | undefined
>({});
